type FloatingImage = {
    id: number;
    imageUrl: string;
    title: string;
    style: {
        width: string;
        aspectRatio: string;
        left: string;
        top: string;
    };
};

const floatingImages: FloatingImage[] = [
    {
        id: 1,
        title: 'prepair to bowl',
        imageUrl:
            "/waroeng_temp/waroeng_3.jpeg",
        style: { width: '15%', aspectRatio: '2 / 1', left: '5%', top: '10%' },
    },
    {
        id: 2,
        title: 'welcome home',
        imageUrl:
            "/waroeng_temp/waroeng_4.jpeg",
        style: { width: '20%', aspectRatio: '1 / 1', left: '45%', top: '18%' },
    },
    {
        id: 3,
        title: 'prepair to bowl',
        imageUrl:
            "/waroeng_temp/waroeng_2.jpeg",
        style: { width: '20%', aspectRatio: '3 / 2', left: '75%', top: '40%' },
    },
    {
        id: 4,
        title: 'estafet',
        imageUrl:
            "/waroeng_temp/waroeng_1.jpeg",
        style: { width: '18%', aspectRatio: '5 / 4', left: '12%', top: '60%' },
    },
];

export const LandingPage = () => {
    return (
        <div className="relative min-h-screen bg-forest-green text-white pt-navbar">
            <h2 className="text-4xl md:text-5xl lg:text-6xl w-full absolute left-1/2 md:left-[85%] transform -translate-x-1/2 top-[40%] text-center md:text-left px-4">
                PERMIKA Waroeng
            </h2>
            {/* Desktop images */}
            <div className="hidden md:block">
                {floatingImages.map((image) => (
                    <div
                        key={image.id}
                        style={{
                            ...image.style,
                            position: 'absolute',
                        }}
                        className="group transition-transform duration-300 ease-in-out transform hover:scale-105"
                    >
                        <img
                            className="opacity-50 group-hover:opacity-100"
                            src={image.imageUrl}
                            alt={`Event ${image.id}`}
                            style={{ width: '100%', height: 'auto' }}
                        />
                    </div>
                ))}
            </div>
            {/* Mobile images - simplified layout */}
            <div className="md:hidden">
                <div className="absolute" style={{ width: '30%', left: '5%', top: '20%' }}>
                    <img
                        className="opacity-50"
                        src="/waroeng_temp/waroeng_3.jpeg"
                        alt="Waroeng"
                        style={{ width: '100%', height: 'auto' }}
                    />
                </div>
                <div className="absolute" style={{ width: '35%', right: '10%', top: '25%' }}>
                    <img
                        className="opacity-50"
                        src="/waroeng_temp/waroeng_4.jpeg"
                        alt="Waroeng"
                        style={{ width: '100%', height: 'auto' }}
                    />
                </div>
                <div className="absolute" style={{ width: '40%', left: '20%', bottom: '15%' }}>
                    <img
                        className="opacity-50"
                        src="/waroeng_temp/waroeng_1.jpeg"
                        alt="Waroeng"
                        style={{ width: '100%', height: 'auto' }}
                    />
                </div>
            </div>
        </div>
    )
}